<!-- @if(!appLoaded){
<div class="loading"></div>
}@else{ -->
<router-outlet [ngClass]="{ 'app-loading': !appLoaded }"></router-outlet>
<!-- } -->
